import {Box, CircularProgress, CircularProgressLabel, Flex, HStack, Text, VStack,} from "@chakra-ui/react";
import {useState, useEffect} from "react";
import { ReactComponent as UsersIcon} from "../../../../assets/icons/profile/transaction_icon.svg";
import {StyledButton} from "../../../../components";

export const TransferConfirm = ({initialMinutes = 5, isMobile}) => {
    const [timeLeft, setTimeLeft] = useState(initialMinutes * 60);
    const totalTime = initialMinutes * 60;

    useEffect(() => {
        if (timeLeft <= 0) return;

        const interval = setInterval(() => {
            setTimeLeft(prevTime => prevTime - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [timeLeft]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    };

    const getBorderColor = () => {
        const progress = timeLeft / totalTime;

        const startColor = [112, 18, 206];
        const endColor = [27, 20, 63];

        const interpolatedColor = startColor.map((start, i) =>
            Math.round(start + (endColor[i] - start) * (1 - progress))
        );

        return `rgb(${interpolatedColor.join(",")})`;
    };


    return (
        <Box w={'full'}>
            <Flex
                w={'full'}
                justifyContent={'center'}>
                <CircularProgress
                    size="120px"
                    value={(timeLeft / totalTime) * 100}
                    thickness="8px"
                    trackColor="rgba(255, 255, 255, 0.1)"
                    color={getBorderColor()}>
                    <CircularProgressLabel fontSize="16px" fontWeight="bold">
                        {formatTime(timeLeft)}
                    </CircularProgressLabel>
                </CircularProgress>
            </Flex>
            <Box>
                <Flex
                    gap={'16px'}>
                    <Flex
                        alignItems={'center'}
                        justifyContent={'center'}
                        borderRadius={'8px'}
                        bg={'purple.500'}
                        h={'32px'}
                        w={'32px'}>
                        <UsersIcon />
                    </Flex>
                    <VStack
                        align={'start'}
                        w={'full'}
                        gap={isMobile ? '16px' :'24px'}>
                        <Text fontSize={isMobile ? 'body.md' :'body.lg'}>Transaction ID</Text>
                        <Flex
                            w={'full'}
                            alignItems={'center'}
                            px={'16px'}
                            fontSize={isMobile ? 'body.sm' :'body.md'}
                            h={isMobile ? '40px' : '56px'}
                            borderRadius={'8px'}
                            bg={'#23262F'}>
                            AB123456789
                        </Flex>
                    </VStack>
                </Flex>
                <HStack
                    flexDirection={isMobile ? 'column' : 'row'}
                    mt={isMobile ? '50px' :'250px'}
                    gap={'16px'}
                    w={'full'}>
                    <StyledButton
                        // onClick={cancelSteps}
                        bg={'#6F41D240'}
                        h={isMobile ? '40px' : '56px'}
                        w={'full'}>
                        Skip
                    </StyledButton>
                    <StyledButton
                        // onClick={addStep}
                        h={isMobile ? '40px' : '56px'}
                        w={'full'}>
                        Submit
                    </StyledButton>
                </HStack>
            </Box>
        </Box>
    )
}